module["exports"] = ["北", "東", "西", "南", "新", "湖", "港"];